// Write your code here
import './index.css'

const Header = () => (
  <div className="header-container">
    <h1 className="header-heading">Header</h1>
  </div>
)

export default Header
